import { InvalidMessageWrapper } from './styled';

interface Props {
  name: string;
  message: string;
}

const InvalidMessage = ({ name, message }: Props) => {
  return (
    <InvalidMessageWrapper>
      <span data-cy-id={name}>{message}</span>
    </InvalidMessageWrapper>
  );
};

export default InvalidMessage;
